import React from 'react';
import './style.scss';
const Loader = (props) => (
  <div><span className="spinner tds-icon-loader-1-static-red-18"></span></div>
);

export default Loader;
